// This function return the list of Index that includes the indexRef, if the list is empty is because the key is wrong.
//  Otherwise it should at least return the indexRef.
export function getSpannedRowIndexes<RowType>(
  rowIndex: number,
  data: RowType[],
  columnKey: keyof RowType,
): number[] {
  const value = data[rowIndex]?.[columnKey]

  if (!value) return []

  const listOfIndex = [rowIndex]

  // Moving foward (index) to check following rows value
  for (let index = rowIndex + 1; index < data.length; index++) {
    const currentValue = data[index][columnKey]
    if (value === currentValue) {
      listOfIndex.push(index)
    } else {
      break
    }
  }

  // Moving backward (index) to check previous rows value
  for (let index = rowIndex - 1; index >= 0; index--) {
    const currentValue = data[index][columnKey]
    if (value === currentValue) {
      listOfIndex.unshift(index)
    } else {
      break
    }
  }

  return listOfIndex
}
